import React from 'react'
import { connect } from 'react-redux'
import GenericIcon from 'components/GenericIcon'
import Income from './Income'
import MainIncome from './MainIncome'

class Incomes extends React.Component {
  renderAdditionalIncomes(incomes) {
    return incomes.map((income) => (
      <Income income={income}
              key={ income.id }
      />
    ))
  }

  render() {
    const {
      primaryUser,
      secondaryUser,
      incomes,
      onGoToClick,
    } = this.props

    const reviewIncome = (mainIncome, additionalIncomes, incomeEmployerType, creditSenseEnabled, name) => {
      return (
            <div className='card card-single'>
              <div className='card-header'>
                <div className='pull-right'>
                  <a className='smaller' href='#' onClick={ () => onGoToClick('income')}>Edit</a>
                </div>
                Your income - {name}
              </div>
              <div className='card-body'>
                <MainIncome income={mainIncome}
                            incomeEmployerType={incomeEmployerType}/>

                { this.renderAdditionalIncomes(additionalIncomes) }

                { creditSenseEnabled &&
                <div>
                  <hr/>
                  <div className='justify-content-between d-sm-flex'>
                    <b>Verified by Credit Sense</b>
                    <div className='align-self-center d-none d-sm-block'>
                      <GenericIcon name='creditSense' />
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          )
      }

    if (incomes && incomes.length) {
      return incomes.map((incomes, index) => {
        const { profiles } = this.props
        const isPrimaryUser = index === 0
        const incomeEmployerType = isPrimaryUser ? primaryUser.incomeEmployerType : secondaryUser.incomeEmployerType;
        const creditSenseEnabled = isPrimaryUser ? primaryUser.creditSenseEnabled : secondaryUser.creditSenseEnabled;
        const name = profiles[index].name

        if (incomes[0].amount === 0 && incomes[0].amountPreviousYear === 0) {
          return null
        }

        return (
          reviewIncome(incomes[0], incomes.slice(1), incomeEmployerType, creditSenseEnabled, name)
        )
      })
    } else {
      return null
    }
  }
}

const mapStateToProps = (state) => ({
  primaryUser: state.loanApplicationUser.primary,
  secondaryUser: state.loanApplicationUser.secondary,
  profiles: state.review.profile,
  incomes: state.review.incomes,
})

export default connect(mapStateToProps)(Incomes)
